import classNames from 'classnames';
import { FixedLengthArray, LegendColorBarValuesOverDivision } from 'components/legends/legend-flex-division.js';
import { WeatherStationLocationType } from 'types/markerTypes/marker.weatherStation.js';
import { predicateNumber } from 'utilities/isType.js';
import { getSoilData } from './station-utils-soil.js';
import { getBackgroundColor } from './utils.js';

export const getSoilMoisture = (value: WeatherStationLocationType['value']) => {
  const soil = getSoilData(value);
  if (soil) {
    return soil.moisture;
  }
  return undefined;
};

export const WeatherStationSoilMoistureChild = ({
  soilMoisture,
  selected,
}: {
  soilMoisture: number | undefined;
  selected?: boolean;
}) => {
  if (predicateNumber(soilMoisture)) {
    return (
      <div className="Map-pin-content-text">
        <span className={`${classNames({ 'u-textDefault': !selected })}`}>{`${soilMoisture}%`}</span>
      </div>
    );
  }
  return null;
};

export const colorSoilMoisture: FixedLengthArray<[number, string], 10> = [
  [10, '#740700'],
  [20, '#AA221A'],
  [30, '#E94036'],
  [40, '#DB8342'],
  [50, '#9CDA4E'],
  [60, '#48B752'],
  [70, '#239F74'],
  [80, '#70A6D1'],
  [90, '#4F6CB6'],
  [100, '#102E78'],
];

/* We return the lowest one by default */
export const getBackgroundColorSoilMoisture = getBackgroundColor(colorSoilMoisture);

export const KeyBarSoilMoisture = () => {
  /** The key temp guage gives color on basis of if temp is in range. 0 is the bottom range so we miss this out
   * As we want values over the divisions
   */
  const vals = ['0', ...colorSoilMoisture.map(([n, _]) => n)] as FixedLengthArray<string, 11>;
  const colors = colorSoilMoisture.map(([_, v]) => v) as FixedLengthArray<string, 10>;
  return <LegendColorBarValuesOverDivision vals={vals} colors={colors} valsClasses="u-textBold" />;
};
